const LOADING_CLASS = "page-is-loading";
const SHOW_DELAY = 120;

let loadingTimer = null;

const overlay = () => document.getElementById("page-loading-overlay");

const showLoader = () => {
  const loadingOverlay = overlay();

  if (!loadingOverlay) return;

  loadingOverlay.setAttribute("aria-hidden", "false");
  document.body.classList.add(LOADING_CLASS);
};

const showLoaderSoon = () => {
  if (document.body.classList.contains(LOADING_CLASS) || loadingTimer) return;

  loadingTimer = window.setTimeout(() => {
    loadingTimer = null;
    showLoader();
  }, SHOW_DELAY);
};

const hideLoader = () => {
  const loadingOverlay = overlay();

  if (loadingTimer) {
    window.clearTimeout(loadingTimer);
    loadingTimer = null;
  }

  document.body.classList.remove(LOADING_CLASS);

  if (loadingOverlay) {
    loadingOverlay.setAttribute("aria-hidden", "true");
  }
};

const hasNavigationModifier = (event) => (
  event.defaultPrevented ||
  event.button !== 0 ||
  event.metaKey ||
  event.ctrlKey ||
  event.shiftKey ||
  event.altKey
);

const skipsLoader = (element) => {
  if (!element) return true;

  const toggle = element.getAttribute("data-bs-toggle") || element.getAttribute("data-toggle");
  const turbolinks = element.getAttribute("data-turbolinks");

  return (
    element.hasAttribute("download") ||
    element.getAttribute("data-no-loader") === "true" ||
    turbolinks === "false" ||
    ["modal", "collapse", "dropdown", "tab", "pill"].includes(toggle)
  );
};

const shouldShowForLink = (event) => {
  if (hasNavigationModifier(event)) return false;

  const link = event.target.closest("a[href]");

  if (skipsLoader(link)) return false;

  const target = link.getAttribute("target");
  const href = link.getAttribute("href");

  if ((target && target !== "_self") || !href || href.charAt(0) === "#") return false;

  try {
    const url = new URL(link.href, window.location.href);
    const samePageAnchor = (
      url.origin === window.location.origin &&
      url.pathname === window.location.pathname &&
      url.search === window.location.search &&
      url.hash
    );

    return !samePageAnchor;
  } catch (_) {
    return true;
  }
};

const shouldShowForForm = (event) => {
  const form = event.target;

  if (!form || event.defaultPrevented || skipsLoader(form)) return false;

  const target = form.getAttribute("target");
  const action = form.getAttribute("action");

  return target !== "_blank" && action !== "#";
};

document.addEventListener("click", (event) => {
  if (shouldShowForLink(event)) showLoaderSoon();
}, true);

document.addEventListener("submit", (event) => {
  if (shouldShowForForm(event)) showLoaderSoon();
}, true);

document.addEventListener("turbolinks:request-start", showLoaderSoon);
document.addEventListener("turbolinks:before-cache", hideLoader);
document.addEventListener("turbolinks:load", hideLoader);
document.addEventListener("turbolinks:render", hideLoader);
document.addEventListener("turbolinks:request-end", (event) => {
  if (event.data && event.data.xhr && event.data.xhr.status >= 400) hideLoader();
});

window.addEventListener("pageshow", hideLoader);
window.addEventListener("beforeunload", showLoader);
